<template>
  <v-dialog v-model="dialog" persistent max-width="500px">
    <v-card>
      <v-card-title>
        <app-title>Alterar senha</app-title>
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col cols="12">
            <app-password-field outlined label="Senha atual" v-model="form.oldPassword" />
          </v-col>
          <v-col cols="12">
            <app-password-field outlined label="Nova Senha" v-model="form.newPassword" />
          </v-col>
          <v-col cols="12">
            <app-password-field outlined label="Confirme sua senha" v-model="form.newPassword_confirmation" />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <app-back-btn @click="$router.go(-1)" />
        <v-spacer v-if="$vuetify.breakpoint.mobile" />
        <app-confirm-btn @click="store()" class="mr-2" />
      </v-card-actions>


    </v-card>
  </v-dialog>
</template>
<script>
export default {
  components: {},
  data: () => ({
    dialog: false,
    form: {},
    baseForm: {
      oldPassword: null,
      newPassword: null,
      newPassword_confirmation: null,
    },
  }),
  methods: {
    async open() {
      await this.reset();
      this.dialog = true;
    },

    reset() {
      this.form = JSON.parse(JSON.stringify(this.baseForm));
    },

    async store() {
      this.$loading.start();
      await this.$http
        .store("user/update-password", this.form)
        .then((response) => {
          this.$loading.finish();
          this.dialog = false;
        })
        .catch((error) => {
          this.$loading.finish();
        });
    },
  },
};
</script>
